export const isJsonStructure = (attributeValue) => {
  if (typeof attributeValue !== "string") return false
  try {
    JSON.parse(attributeValue)
  } catch {
    return false
  }
  return true
}
